module.exports = __webpack_public_path__ + "img/40_10.1840da37.png";